

import { GoogleMapsProvider } from './google-maps-provider';
import { useMapProvider } from './map-context';
import { BaseMapProps } from './types';

export interface UnifiedMapProps extends Omit<BaseMapProps, 'provider'> { }

export function UnifiedMap(mapProps: UnifiedMapProps) {
  const { isLoaded } = useMapProvider();

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center h-full w-full bg-muted">
        <div className="text-center p-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
          <p className="text-sm text-muted-foreground">Initialisation...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full">
      <GoogleMapsProvider {...mapProps} />
    </div>
  );
}
